import { createAsyncThunk } from '@reduxjs/toolkit';

import { TrackingEventEnum } from '../../../../main/constants/tracking-event.ts';
import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { AppStateEnum } from '../../../../main/types/app-state.types.ts';

import { selectCurrentLessonTaskStepKey } from '../../../selectors/current-lesson-task-step-key.selector.ts';

import { updateAppStateThunk } from '../../app-state/thunks/update-app-state.thunk.ts';
import { trackProgressionEventThunk } from '../../progress/thunks/track-progression-event.thunk.ts';

import { incrementTaskStepViewCount } from '../lesson.slice.ts';
import { LESSON_SLICE_NAME } from '../lesson.slice.types.ts';

import { preloadLessonAssetsThunk } from './preload-lesson-assets.thunk.ts';

interface Props {
  blockAnimation?: boolean;
}

const THUNK_NAME = `${LESSON_SLICE_NAME}/navigateToStepThunk`;

export const navigateToStepThunk = createAsyncThunk<void, Props, ThunkApiConfigType>(
  THUNK_NAME,
  async (props, thunkAPI): Promise<void> => {
    const { blockAnimation = false } = props;

    const state = thunkAPI.getState();
    const index = selectCurrentLessonTaskStepKey(state);
    thunkAPI.dispatch(preloadLessonAssetsThunk({ lessonKey: index.lesson }));

    thunkAPI.dispatch(trackProgressionEventThunk({ event: TrackingEventEnum.STEP_NAVIGATED }));
    thunkAPI.dispatch(incrementTaskStepViewCount());
    await thunkAPI.dispatch(updateAppStateThunk({ state: AppStateEnum.ReadyToStart, blockAnimation })).unwrap();
  }
);
